export const ERROR_TYPES = {
  NOT_FOUND: 'NOT_FOUND'
};